export default __webpack_public_path__ + "static/media/mobile-1.0399b640.png";